<app-dash></app-dash>
<google-map
  height="400px"
  width="100%"
></google-map>
<router-outlet></router-outlet>
